import React from "react";
import {Button, Form} from 'antd';

const BasicFormButtons = ({handleReset, noReset = false}) => {
    return (
        <Form.Item>
            <Button.Group>
                <Button type="default" htmlType="submit">
                    Submit
                </Button>
                {!noReset && (
                    <Button type="danger" htmlType="button" onClick={handleReset}>
                        Reset
                    </Button>
                )}
            </Button.Group>
        </Form.Item>
    )
};




export default BasicFormButtons;